<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper p-0">
     <!-- MOBILE VIEW (Aesthetic Modern) -->
     <div v-if="!isLoadingData" class="content d-lg-none mob-edit-member p-0">
        <!-- Modern Header -->
        <div class="mob-sticky-header-form bg-white shadow-xs px-3 py-3 d-flex align-items-center gap-3">
           <a href="javascript:void(0);" @click="router.push('/people/kios-list')" class="btn-back-mob shadow-sm">
              <vue-feather type="arrow-left" size="20"></vue-feather>
           </a>
           <h5 class="fw-800 mb-0 text-dark">Perbarui Data Kios</h5>
        </div>

        <div class="px-3 pt-4 pb-5 mb-5">
           <!-- Section: Info Dasar -->
           <div class="mob-form-card bg-white shadow-xs rounded-4 p-4 mb-4">
              <div class="d-flex align-items-center gap-2 mb-4">
                 <div class="section-icon bg-success-soft text-success">
                    <vue-feather type="edit-3" size="16"></vue-feather>
                 </div>
                 <h6 class="fw-800 mb-0 text-dark uppercase tracking-wider">Identitas Kios</h6>
              </div>

              <div class="mb-3">
                 <label class="mob-label">Nama Pemilik <span class="text-danger">*</span></label>
                 <input type="text" v-model="formData.nama_member" class="mob-input" required>
              </div>
              <div class="mb-3">
                 <label class="mob-label">Nama Toko / Kios <span class="text-danger">*</span></label>
                 <input type="text" v-model="formData.nama_toko" class="mob-input" required>
              </div>
              <div class="mb-3">
                 <label class="mob-label">Nomor WhatsApp</label>
                 <input type="tel" v-model="formData.nomor_handphone" class="mob-input">
              </div>
              <div class="mb-4">
                 <label class="mob-label">Petugas Pendamping</label>
                 <vue-select
                   :options="pendampingOptions"
                   v-model="formData.pendamping_id"
                   placeholder="Pilih Petugas..."
                   @select="formData.pendamping_id = $event.id"
                   class="mob-select"
                 />
              </div>
              <div class="mb-0">
                 <label class="mob-label">Alamat Lengkap</label>
                 <textarea v-model="formData.alamat" class="mob-input" rows="3"></textarea>
              </div>
           </div>

           <!-- Section: Status Member -->
           <div class="mob-form-card bg-white shadow-xs rounded-4 p-4 mb-4">
              <div class="d-flex align-items-center gap-2 mb-3">
                 <div class="section-icon bg-warning-soft text-warning">
                    <vue-feather type="activity" size="16"></vue-feather>
                 </div>
                 <h6 class="fw-800 mb-0 text-dark uppercase tracking-wider">Status Operasional</h6>
              </div>
              
              <div class="d-flex gap-2">
                 <div class="flex-fill">
                    <input type="radio" class="btn-check" v-model="formData.status" value="active" id="mobStatusActive">
                    <label class="btn btn-outline-success w-100 rounded-3 py-2 fw-bold" for="mobStatusActive">AKTIF</label>
                 </div>
                 <div class="flex-fill">
                    <input type="radio" class="btn-check" v-model="formData.status" value="inactive" id="mobStatusInactive">
                    <label class="btn btn-outline-secondary w-100 rounded-3 py-2 fw-bold" for="mobStatusInactive">OFF</label>
                 </div>
              </div>
           </div>

           <!-- Section: Lokasi Maps -->
           <div class="mob-form-card bg-white shadow-xs rounded-4 p-4 mb-4">
              <div class="d-flex align-items-center gap-2 mb-4">
                 <div class="section-icon bg-blue-soft text-blue">
                    <vue-feather type="map-pin" size="16"></vue-feather>
                 </div>
                 <h6 class="fw-800 mb-0 text-dark uppercase tracking-wider">Lokasi Presisi</h6>
              </div>

              <div class="mb-3">
                 <label class="mob-label">Koordinat Maps</label>
                 <div class="position-relative">
                    <input 
                       type="text" 
                       v-model="formData.koordinat" 
                       class="mob-input ps-5" 
                       @input="handleCoordinatePaste"
                    >
                    <vue-feather type="crosshair" size="16" class="mob-input-icon text-muted"></vue-feather>
                 </div>
              </div>
              <div class="row g-2">
                 <div class="col-6">
                    <input type="text" v-model="formData.latitude" class="mob-input bg-light-soft border-0 smallest" readonly placeholder="Lat">
                 </div>
                 <div class="col-6">
                    <input type="text" v-model="formData.longitude" class="mob-input bg-light-soft border-0 smallest" readonly placeholder="Long">
                 </div>
              </div>
           </div>

           <!-- Section: Berkas & Foto -->
           <div class="mob-form-card bg-white shadow-xs rounded-4 p-4 mb-4">
              <div class="d-flex align-items-center gap-2 mb-4">
                 <div class="section-icon bg-purple-soft text-purple">
                    <vue-feather type="camera" size="16"></vue-feather>
                 </div>
                 <h6 class="fw-800 mb-0 text-dark uppercase tracking-wider">Berkas Pendukung</h6>
              </div>

              <div class="row g-3">
                 <template v-for="(label, key) in photoTypes" :key="key">
                    <div :class="key === 'logo_toko' ? 'col-12' : 'col-6'">
                       <label class="mob-label">{{ label }}</label>
                       <div :class="key === 'logo_toko' ? 'mob-upload-box-wide' : 'mob-upload-box'" @click="triggerFileInput(key)">
                          <img v-if="previews[key]" :src="getImageSource(previews[key])" :class="key === 'logo_toko' ? 'preview-full object-fit-contain p-2' : 'preview-full'">
                          <div v-else class="upload-placeholder">
                             <vue-feather :type="getIconForType(key)" size="24" class="text-muted"></vue-feather>
                          </div>
                          <button v-if="previews[key]" class="mob-btn-remove" @click.stop="removeImage(key)">
                             <vue-feather type="x" size="12"></vue-feather>
                          </button>
                       </div>
                    </div>
                 </template>
              </div>

              <!-- Barcode Preview -->
              <div class="mt-4 pt-2 border-top">
                 <label class="mob-label">Kode Barcode Aktif <span class="text-danger">*</span></label>
                 <div class="bg-light-soft rounded-3 p-3 text-center border-dashed">
                    <h5 class="fw-800 mb-0 text-dark" style="letter-spacing: 2px;">
                       {{ formData.kode_barcode || 'TIDAK ADA KODE' }}
                    </h5>
                    <small class="text-muted smallest uppercase fw-bold">ID MEMBER SSP</small>
                 </div>
                 <input type="hidden" v-model="formData.kode_barcode" required>
              </div>
           </div>
        </div>

        <!-- Sticky Footer Action -->
        <div class="mob-sticky-footer bg-white border-top p-3 shadow-lg">
           <div class="d-flex gap-2">
              <button @click="resetToOriginal" class="btn btn-outline-secondary rounded-pill px-4" :disabled="isSubmitting">
                 RESET
              </button>
              <button 
                v-if="$hasPermission('ssp', 'members', 'edit')"
                @click="submitForm" 
                class="btn btn-success flex-fill rounded-pill py-3 fw-800 shadow-sm d-flex align-items-center justify-content-center gap-2" 
                :disabled="isSubmitting"
               >
                 <vue-feather v-if="!isSubmitting" type="check" size="18"></vue-feather>
                 <span v-if="isSubmitting" class="spinner-border spinner-border-sm me-2"></span>
                 {{ isSubmitting ? 'MENYIMPAN...' : 'SIMPAN PERUBAHAN' }}
              </button>
           </div>
        </div>

        <!-- Hidden Inputs -->
        <input v-for="(label, key) in photoTypes" :key="'in-'+key" type="file" :ref="el => fileRefs[key] = el" @change="handleFileSelect($event, key)" accept="image/*" style="display: none;">
     </div>
     
     <div v-if="isLoadingData" class="d-flex align-items-center justify-content-center" style="min-height: 80vh;">
        <div class="spinner-border text-success" role="status"></div>
     </div>

     <!-- DESKTOP VIEW (Classic Aesthetic) -->
     <div class="content d-none d-lg-block">
       <!-- Page Header -->
       <div class="page-header">
         <div class="add-item d-flex">
           <div class="page-title">
             <h4>Edit Kios SSP</h4>
             <h6>Perbarui Informasi Member</h6>
           </div>
         </div>
         <div class="page-btn">
           <router-link to="/people/kios-list" class="btn btn-outline-secondary">
             <vue-feather type="chevron-left" class="me-2" style="width: 18px;"></vue-feather>Kembali
           </router-link>
         </div>
       </div>

       <!-- Form Content -->
       <form @submit.prevent="submitForm">
         <div class="row">
           <!-- Left Column -->
           <div class="col-lg-8">
             <!-- Informasi Dasar -->
             <div class="card border-0 shadow-sm mb-3">
               <div class="card-body">
                 <h6 class="fw-bold mb-3 text-dark">Informasi Dasar</h6>
                 <div class="row">
                   <div class="col-md-6 mb-3">
                     <label class="form-label small text-muted">Nama Pemilik <span class="text-danger">*</span></label>
                     <input type="text" v-model="formData.nama_member" class="form-control form-control-sm" required>
                   </div>
                   <div class="col-md-6 mb-3">
                     <label class="form-label small text-muted">Nama Toko <span class="text-danger">*</span></label>
                     <input type="text" v-model="formData.nama_toko" class="form-control form-control-sm" required>
                   </div>
                   <div class="col-md-6 mb-3">
                     <label class="form-label small text-muted">Nomor HP/WhatsApp</label>
                     <input type="tel" v-model="formData.nomor_handphone" class="form-control form-control-sm">
                   </div>
                   <div class="col-md-6 mb-3">
                     <label class="form-label small text-muted">Pendamping</label>
                     <vue-select
                       :options="pendampingOptions"
                       v-model="formData.pendamping_id"
                       placeholder="Pilih Pendamping..."
                       @select="formData.pendamping_id = $event.id"
                     />
                   </div>
                   <div class="col-12 mb-0">
                     <label class="form-label small text-muted">Alamat Lengkap</label>
                     <textarea v-model="formData.alamat" class="form-control form-control-sm" rows="2"></textarea>
                   </div>
                 </div>
               </div>
             </div>

             <!-- Koordinat -->
             <div class="card border-0 shadow-sm mb-3">
               <div class="card-body">
                 <h6 class="fw-bold mb-3 text-dark">Koordinat Lokasi</h6>
                 <div class="row">
                   <div class="col-12 mb-3">
                     <label class="form-label small text-muted">Paste Koordinat dari Google Maps</label>
                     <input 
                       type="text" 
                       v-model="formData.koordinat" 
                       class="form-control form-control-sm" 
                       placeholder="Paste: -8.509153, 114.221324"
                       @input="handleCoordinatePaste"
                     >
                   </div>
                   <div class="col-md-6 mb-3">
                     <label class="form-label small text-muted">Latitude</label>
                     <input type="text" v-model="formData.latitude" class="form-control form-control-sm bg-light" readonly>
                   </div>
                   <div class="col-md-6 mb-3">
                     <label class="form-label small text-muted">Longitude</label>
                     <input type="text" v-model="formData.longitude" class="form-control form-control-sm bg-light" readonly>
                   </div>
                 </div>
               </div>
             </div>

             <!-- Status -->
             <div class="card border-0 shadow-sm mb-3">
               <div class="card-body">
                 <h6 class="fw-bold mb-3 text-dark">Status Member</h6>
                 <div class="d-flex gap-3">
                   <div class="form-check">
                     <input class="form-check-input" type="radio" v-model="formData.status" value="active" id="statusActive">
                     <label class="form-check-label" for="statusActive">Aktif</label>
                   </div>
                   <div class="form-check">
                     <input class="form-check-input" type="radio" v-model="formData.status" value="inactive" id="statusInactive">
                     <label class="form-check-label" for="statusInactive">Tidak Aktif</label>
                   </div>
                 </div>
               </div>
             </div>

            <!-- Submit Actions (Moved here to be aligned with form) -->
            <div class="card border-0 shadow-sm mb-3">
              <div class="card-body d-flex justify-content-end gap-2">
                <button type="button" class="btn btn-outline-secondary" @click="resetToOriginal">
                  Batalkan Perubahan
                </button>
                <button 
                   v-if="$hasPermission('ssp', 'members', 'edit')"
                   type="submit" 
                   class="btn btn-success px-5" 
                   :disabled="isSubmitting"
                 >
                  <vue-feather type="save" class="me-2" style="width: 18px;"></vue-feather>
                  {{ isSubmitting ? 'Menyimpan...' : 'Simpan Perubahan' }}
                </button>
              </div>
            </div>
          </div>

           <!-- Right Column (Upload Photos) -->
           <div class="col-lg-4">
             <div class="card border-0 shadow-sm mb-3">
               <div class="card-body">
                 <h6 class="fw-bold mb-3 text-dark">Foto & Berkas</h6>
                 
                 <!-- Photo Upload Components (Reusable) -->
                 <template v-for="(label, key) in photoTypes" :key="key">
                   <div class="mb-3">
                     <label class="form-label small text-muted mb-1">{{ label }}</label>
                     <div 
                       class="dropzone-compact" 
                       :class="{ 'dropzone-qr': key === 'qr_code', 'scanning': key === 'qr_code' && isScanning }"
                       @click="triggerFileInput(key)"
                       @dragover.prevent
                       @drop.prevent="handleDrop($event, key)"
                     >
                       <div v-if="previews[key]" class="preview-img">
                         <img :src="getImageSource(previews[key])" alt="Preview">
                         <button type="button" class="btn-remove" @click.stop="removeImage(key)">
                           <vue-feather type="x" style="width: 12px;"></vue-feather>
                         </button>
                       </div>
                       <div v-else class="dropzone-empty">
                         <vue-feather :type="getIconForType(key)" class="text-muted" :class="{ 'scanning-icon': key === 'qr_code' && isScanning }" style="width: 24px;"></vue-feather>
                         <small class="text-muted mt-1">{{ isScanning && key === 'qr_code' ? 'Memindai...' : 'Klik atau Drag & Drop' }}</small>
                       </div>
                     </div>
                     <input type="file" :ref="el => fileRefs[key] = el" @change="handleFileSelect($event, key)" accept="image/*" style="display: none;">
                   </div>
                 </template>

                 <!-- Barcode Code -->
                 <div class="mb-0">
                   <label class="form-label small text-muted mb-1">Kode Barcode <span class="text-danger">*</span></label>
                   <input 
                     type="text" 
                     v-model="formData.kode_barcode" 
                     class="form-control form-control-sm" 
                     required
                   >
                 </div>
               </div>
             </div>
           </div>
         </div>

         <!-- Submit Actions -->
         <!-- This section is moved to be inside col-lg-8 -->
       </form>
     </div>
  </div>
</template>

<script>
import { ref, onMounted, reactive, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useDataStore } from "@/store/dataStore";
import memberService from '@/services/memberService';
import pendampingService from '@/services/pendampingService';
import Swal from 'sweetalert2';
import jsQR from 'jsqr';

export default {
  setup() {
    const router = useRouter();
    const route = useRoute();
    const memberId = route.params.id;
    
    const isSubmitting = ref(false);
    const isLoadingData = ref(true);
    const isScanning = ref(false);
    const originalData = ref(null);
    const apiBaseUrl = process.env.VUE_APP_API_URL || '';

    const formData = reactive({
      nama_member: '',
      nama_toko: '',
      nomor_handphone: '',
      alamat: '',
      latitude: '',
      longitude: '',
      koordinat: '',
      pendamping_id: '',
      kode_barcode: '',
      status: 'active'
    });

    const photoTypes = {
      foto_profil: 'Foto Profil Pemilik',
      foto_toko: 'Foto Toko',
      logo_toko: 'Logo Toko (Opsional)',
      foto_ktp: 'Foto KTP',
      qr_code: 'Scan QR Code Baru'
    };

    const files = reactive({
      foto_profil: null,
      foto_toko: null,
      logo_toko: null,
      foto_ktp: null,
      qr_code: null
    });

    const previews = reactive({
      foto_profil: null,
      foto_toko: null,
      logo_toko: null,
      foto_ktp: null,
      qr_code: null
    });

    const fileRefs = reactive({});
    const pendampingOptions = ref([]);

    const getIconForType = (type) => {
      const icons = {
        foto_profil: 'user',
        foto_toko: 'home',
        logo_toko: 'star',
        foto_ktp: 'credit-card',
        qr_code: 'grid'
      };
      return icons[type] || 'file';
    };

    const getImageSource = (src) => {
      if (!src) return '';
      if (src.startsWith('data:') || src.startsWith('blob:') || src.startsWith('http')) return src;
      return `${apiBaseUrl}/${src}`;
    };

    const loadData = async () => {
      isLoadingData.value = true;
      try {
        // Load pendamping options
        const pendampingData = await pendampingService.getPendampings();
        pendampingOptions.value = (Array.isArray(pendampingData) ? pendampingData : pendampingData.items || [])
          .map(p => ({ id: p.id, text: p.nama_pendamping }));

        // Load member data
        const response = await memberService.getMember(memberId);
        const member = response;
        originalData.value = { ...member };

        // Populate form
        formData.nama_member = member.nama_member || '';
        formData.nama_toko = member.nama_toko || '';
        formData.nomor_handphone = member.nomor_handphone || '';
        formData.alamat = member.alamat || '';
        formData.latitude = member.latitude || '';
        formData.longitude = member.longitude || '';
        formData.pendamping_id = member.pendamping_id || '';
        formData.kode_barcode = member.kode_barcode || '';
        formData.status = member.status || 'active';
        
        if (member.latitude && member.longitude) {
          formData.koordinat = `${member.latitude}, ${member.longitude}`;
        }

        // Set initial previews from server paths
        previews.foto_profil = member.foto_profil;
        previews.foto_toko = member.foto_toko;
        previews.logo_toko = member.logo_toko;
        previews.foto_ktp = member.foto_ktp;
        previews.qr_code = member.barcode_image;

      } catch (error) {
        console.error("Failed to load member data", error);
        Swal.fire('Error', 'Gagal memuat data member', 'error');
        router.push('/people/kios-list');
      } finally {
        isLoadingData.value = false;
      }
    };

    const handleCoordinatePaste = () => {
      if (formData.koordinat) {
        const parts = formData.koordinat.split(',').map(p => p.trim());
        if (parts.length >= 2) {
          formData.latitude = parts[0];
          formData.longitude = parts[1];
        }
      }
    };

    const triggerFileInput = (type) => {
      if (fileRefs[type]) fileRefs[type].click();
    };

    const handleFileSelect = (event, type) => {
      const file = event.target.files[0];
      if (file) processFile(file, type);
    };

    const handleDrop = (event, type) => {
      const file = event.dataTransfer.files[0];
      if (file && file.type.startsWith('image/')) processFile(file, type);
    };

    const processFile = (file, type) => {
      files[type] = file;
      const reader = new FileReader();
      reader.onload = (e) => {
        previews[type] = e.target.result;
        if (type === 'qr_code') scanQRCode(e.target.result);
      };
      reader.readAsDataURL(file);
    };

    const scanQRCode = async (imageSrc) => {
      isScanning.value = true;
      try {
        const image = new Image();
        image.src = imageSrc;
        await new Promise(resolve => image.onload = resolve);
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.width = image.width;
        canvas.height = image.height;
        context.drawImage(image, 0, 0);
        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        const code = jsQR(imageData.data, imageData.width, imageData.height);
        if (code) {
          formData.kode_barcode = code.data;
          Swal.fire({ toast: true, position: 'top-end', icon: 'success', title: 'Barcode terdeteksi!', showConfirmButton: false, timer: 1500 });
        }
      } finally {
        isScanning.value = false;
      }
    };

    const removeImage = (type) => {
      files[type] = null;
      previews[type] = null;
      // We don't clear the barcode if QR is removed in edit mode
    };

    const resetToOriginal = () => {
      loadData();
    };

    const { refreshData } = useDataStore();

    const submitForm = async () => {
      // Permission double check
      const userStr = localStorage.getItem('currentUser');
      const user = userStr ? JSON.parse(userStr) : null;
      const isAdmin = user?.role === 'admin';
      const perms = user?.permissions?.ssp?.members || [];
      
      if (!isAdmin && !perms.includes('edit')) {
        Swal.fire('Akses Ditolak', 'Anda tidak memiliki izin untuk mengedit data kios', 'error');
        return;
      }

      isSubmitting.value = true;
      try {
        // 1. Prepare text data (JSON)
        // Clean up data for MemberUpdate schema
        const updateData = {
          nama_member: formData.nama_member,
          nama_toko: formData.nama_toko,
          nomor_handphone: formData.nomor_handphone || null,
          alamat: formData.alamat || null,
          latitude: formData.latitude ? String(formData.latitude) : null,
          longitude: formData.longitude ? String(formData.longitude) : null,
          pendamping_id: (formData.pendamping_id && !isNaN(parseInt(formData.pendamping_id))) ? parseInt(formData.pendamping_id) : null,
          kode_barcode: formData.kode_barcode,
          status: formData.status
        };

        // 2. Update text data
        await memberService.updateMember(memberId, updateData);

        // 3. Upload images one by one if they changed
        const apiImageTypeMap = {
          foto_profil: 'profile',
          foto_toko: 'toko',
          logo_toko: 'logo',
          foto_ktp: 'ktp',
          qr_code: 'barcode'
        };

        const uploadPromises = [];
        Object.keys(files).forEach(key => {
          if (files[key]) {
            const apiType = apiImageTypeMap[key];
            if (apiType) {
              uploadPromises.push(memberService.uploadMemberImage(memberId, apiType, files[key]));
            }
          }
        });

        if (uploadPromises.length > 0) {
          await Promise.all(uploadPromises);
        }

        await refreshData('members');

        const toast = Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true
        });

        toast.fire({ 
          icon: 'success', 
          title: 'Data member berhasil diperbarui'
        });
        
        router.push('/people/kios-list');
      } catch (error) {
        console.error("Update failed", error);
        
        let errorMsg = "Gagal memperbarui data";
        if (error.response?.data?.detail) {
          if (Array.isArray(error.response.data.detail)) {
            // FastAPI 422 Errors
            errorMsg = error.response.data.detail.map(err => `${err.loc.join('.')}: ${err.msg}`).join('\n');
          } else {
            errorMsg = error.response.data.detail;
          }
        } else if (typeof error.response?.data === 'string') {
          errorMsg = error.response.data;
        }

        Swal.fire({
          icon: 'error',
          title: 'Update Gagal',
          text: errorMsg,
          confirmButtonText: 'Tutup'
        });
      } finally {
        isSubmitting.value = false;
      }
    };

    onMounted(loadData);

    return {
      formData,
      isLoadingData,
      isSubmitting,
      isScanning,
      photoTypes,
      previews,
      fileRefs,
      pendampingOptions,
      getIconForType,
      getImageSource,
      triggerFileInput,
      handleFileSelect,
      handleDrop,
      removeImage,
      handleCoordinatePaste,
      resetToOriginal,
      submitForm,
      router
    };
  }
};
</script>

<style scoped>
/* Mobile Form Specific Styles */
.mob-edit-member {
    background: #f8fafc;
    min-height: 100vh;
}

.mob-sticky-header-form {
    position: sticky;
    top: 0;
    z-index: 1000;
}

.btn-back-mob {
    width: 44px;
    height: 44px;
    border-radius: 14px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1e293b;
    border: 1px solid #f1f5f9;
    transition: all 0.2s;
}
.btn-back-mob:active {
    transform: scale(0.9);
    background: #f8fafc;
}

.mob-form-card {
    border: 1px solid rgba(0,0,0,0.03);
}

.section-icon {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.mob-label {
    font-size: 11px;
    font-weight: 800;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
    display: block;
}

.mob-input {
    width: 100%;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 12px 14px;
    font-size: 14px;
    font-weight: 600;
    color: #1e293b;
    transition: all 0.2s;
}

.mob-input:focus {
    background: white;
    border-color: #029147;
    box-shadow: 0 0 0 4px rgba(2, 145, 71, 0.08);
    outline: none;
}

.mob-input-icon {
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
}

.mob-upload-box {
    width: 100%;
    aspect-ratio: 1/1;
    background: #f8fafc;
    border: 2px dashed #e2e8f0;
    border-radius: 16px;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}

.mob-upload-box-wide {
    width: 100%;
    height: 80px;
    background: #f8fafc;
    border: 2px dashed #e2e8f0;
    border-radius: 16px;
    position: relative;
    overflow: hidden;
}

.upload-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.preview-full {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.mob-btn-remove {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: rgba(220, 38, 38, 0.9);
    color: white;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(4px);
}

.mob-sticky-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
}

.border-dashed { border-style: dashed !important; }

/* Desktop Classic maintained */
.dropzone-compact {
  border: 1.5px dashed #dee2e6;
  border-radius: 8px;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  background: #fcfcfc;
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}
.dropzone-compact:hover {
  border-color: #28a745;
  background: #f8fff9;
}
.preview-img {
  position: relative;
  width: 100%;
}
.preview-img img {
  width: 100%;
  height: 100px;
  object-fit: cover;
  border-radius: 6px;
}
.btn-remove {
  position: absolute;
  top: -5px;
  right: -5px;
  background: #dc3545;
  color: white;
  border: 2px solid white;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
}
.scanning-icon {
  animation: pulse 1.5s infinite;
}
@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.3; }
  100% { opacity: 1; }
}

.fw-800 { font-weight: 800 !important; }
.uppercase { text-transform: uppercase; }
.tracking-wider { letter-spacing: 0.05em; }

.bg-success-soft { background-color: rgba(2, 145, 71, 0.1); }
.bg-blue-soft { background-color: rgba(37, 99, 235, 0.1); }
.bg-purple-soft { background-color: rgba(147, 51, 234, 0.1); }
.bg-warning-soft { background-color: rgba(245, 158, 11, 0.1); }
.bg-light-soft { background-color: #f1f5f9; }
</style>
